import {
    FaBoxes,
    FaChartLine,
    FaCheckCircle,
    FaClipboardList,
    FaUsers,
} from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const stats = [
    {
        titleKey: 'dashboard.overview.stats.availableProducts',
        value: '15',
        noteKey: 'dashboard.overview.stats.readyInInventory',
        icon: FaBoxes,
        accent: 'bg-emerald-50 text-emerald-700',
    },
    {
        titleKey: 'dashboard.overview.stats.customersWaitlist',
        value: '15',
        noteKey: 'dashboard.overview.stats.waitingForRestock',
        icon: FaUsers,
        accent: 'bg-sky-50 text-sky-700',
    },
    {
        titleKey: 'dashboard.overview.stats.requiredProducts',
        value: '15',
        noteKey: 'dashboard.overview.stats.needAttention',
        icon: FaClipboardList,
        accent: 'bg-amber-50 text-amber-700',
    },
    {
        titleKey: 'dashboard.overview.stats.completedOrders',
        value: '200',
        noteKey: 'dashboard.overview.stats.successfullyDelivered',
        icon: FaCheckCircle,
        accent: 'bg-teal-50 text-teal-700',
    },
];

const Statistics = () => {
    const { t } = useTranslation();
    return (
        <section className="lg:col-span-10 md:col-span-9">
            <div className="rounded-lg border border-slate-200 bg-slate-50/70 p-4 shadow-sm md:p-6">
                <div className="mb-6 flex flex-col justify-between gap-4 rounded-lg bg-white p-5 text-left shadow-sm md:flex-row md:items-center">
                    <div>
                            <p className="text-sm font-semibold uppercase tracking-[0.18em] text-emerald-700">
                            {t('dashboard.overview.label')}
                            </p>
                            <h2 className="mt-2 text-3xl font-semibold text-[#00595A]">
                            {t('dashboard.overview.title')}
                            </h2>
                            <p className="mt-2 max-w-2xl text-sm text-slate-500">
                            {t('dashboard.overview.subtitle')}
                            </p>
                    </div>
                    <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded bg-[#00595A] text-white shadow-sm">
                        <FaChartLine className="h-6 w-6" />
                    </div>
                </div>

                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
                    {stats.map(({ titleKey, value, noteKey, icon: Icon, accent }) => (
                        <article
                            key={titleKey}
                            className="rounded-lg border border-slate-200 bg-white p-5 text-left shadow-sm transition hover:-translate-y-1 hover:shadow-md"
                        >
                            <div className="flex items-start justify-between gap-4">
                                <div>
                                    <p className="text-sm font-medium text-slate-500">
                                        {t(titleKey)}
                                    </p>
                                    <h3 className="mt-3 text-4xl font-semibold text-slate-900">
                                        {value}
                                    </h3>
                                </div>
                                <span className={`grid h-11 w-11 shrink-0 place-items-center rounded ${accent}`}>
                                    <Icon className="h-5 w-5" />
                                </span>
                            </div>
                            <div className="mt-5 h-2 overflow-hidden rounded bg-slate-100">
                                <div className="h-full w-3/4 rounded bg-[#00595A]" />
                            </div>
                            <p className="mt-3 text-sm text-slate-500">
                                {t(noteKey)}
                            </p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default Statistics;
